import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../../hooks/useApi';
import {
  ReceiptIcon, CheckIcon, TruckIcon, XIcon, RefreshIcon,
  ClockIcon, PackageIcon, AlertIcon, MessageIcon,
} from '../../components/Icons';

const ESTADOS = {
  pendente:                { label:'Pendente',           cls:'badge-warning'  },
  confirmada:              { label:'A preparar',         cls:'badge-info'     },
  em_transito_entrega:     { label:'Em trânsito',        cls:'badge-info'     },
  aguardando_levantamento: { label:'Aguarda levantamento',cls:'badge-info'    },
  aluguer_ativo:           { label:'Aluguer activo',     cls:'badge-success'  },
  em_transito_devolucao:   { label:'Em devolução',       cls:'badge-neutral'  },
  em_inspecao:             { label:'Em inspeção',        cls:'badge-warning'  },
  entregue:                { label:'Entregue',           cls:'badge-success'  },
  em_uso:                  { label:'Em uso',             cls:'badge-success'  },
  devolvida:               { label:'Devolvida',          cls:'badge-neutral'  },
  concluida:               { label:'Concluída',          cls:'badge-success'  },
  cancelada:               { label:'Cancelada',          cls:'badge-danger'   },
  disputa:                 { label:'Disputa',            cls:'badge-danger'   },
};

const ESTADOS_CHAT = ['confirmada','em_transito_entrega','aguardando_levantamento','aluguer_ativo','em_transito_devolucao','em_inspecao','entregue','em_uso','devolvida','disputa'];

const ESTADOS_ATIVOS_FORN = ['confirmada','em_transito_entrega','aguardando_levantamento','aluguer_ativo','em_transito_devolucao','em_inspecao','entregue','em_uso','devolvida','disputa'];

function PainelOtp({ titulo, instrucao, otp, onBuscarOtp, inputVal, onChangeInput, onConfirmar, loading, erro, confirmLabel }) {
  return (
    <div style={{background:'var(--orange-light)',border:'1.5px solid var(--orange)',borderRadius:'10px',padding:'14px 16px',marginTop:'10px'}}>
      <div style={{fontSize:'13px',fontWeight:'700',color:'var(--orange-dark)',marginBottom:'4px'}}>{titulo}</div>
      <div style={{fontSize:'12px',color:'var(--text-secondary)',marginBottom:'10px'}}>{instrucao}</div>
      {otp ? (
        <div style={{textAlign:'center',background:'var(--card)',borderRadius:'8px',padding:'12px',border:'1px solid var(--orange)'}}>
          <div style={{fontSize:'11px',color:'var(--text-muted)',marginBottom:'4px',textTransform:'uppercase',letterSpacing:'0.5px'}}>Código OTP</div>
          <div style={{fontSize:'36px',fontWeight:'900',letterSpacing:'10px',color:'var(--orange)',fontVariantNumeric:'tabular-nums'}}>{otp}</div>
          <div style={{fontSize:'11px',color:'var(--text-muted)',marginTop:'4px'}}>Diz verbalmente ao cliente</div>
        </div>
      ) : onBuscarOtp ? (
        <button className="btn btn-sm" onClick={onBuscarOtp} disabled={loading} style={{background:'var(--orange)',color:'#fff',border:'none',width:'100%',justifyContent:'center'}}>
          {loading ? 'A carregar...' : 'Ver código OTP'}
        </button>
      ) : null}
      {onConfirmar && (
        <div style={{marginTop:'10px'}}>
          <div style={{fontSize:'11px',color:'var(--text-secondary)',marginBottom:'5px'}}>Introduz o código recebido do cliente:</div>
          <div style={{display:'flex',gap:'6px'}}>
            <input value={inputVal} onChange={e=>onChangeInput(e.target.value.replace(/\D/,'').slice(0,4))}
              maxLength={4} placeholder="••••"
              style={{flex:1,padding:'9px 12px',border:'1.5px solid var(--border)',borderRadius:'8px',fontSize:'20px',fontWeight:'700',textAlign:'center',letterSpacing:'8px',fontFamily:'inherit',outline:'none',background:'var(--card)',color:'var(--text-primary)'}}/>
            <button className="btn btn-primary" onClick={onConfirmar} disabled={loading||inputVal.length!==4}
              style={{display:'flex',alignItems:'center',gap:'5px',whiteSpace:'nowrap'}}>
              {loading?'...': <><CheckIcon size={13}/> {confirmLabel||'Confirmar'}</>}
            </button>
          </div>
          {erro && <div style={{fontSize:'11px',color:'var(--danger)',marginTop:'5px',display:'flex',gap:'4px',alignItems:'center'}}><AlertIcon size={11}/>{erro}</div>}
        </div>
      )}
    </div>
  );
}

export default function ReservasFornecedor() {
  const navigate = useNavigate();
  const [reservas,   setReservas]   = useState([]);
  const [load,       setLoad]       = useState(true);
  const [activeTab,  setActiveTab]  = useState('todas');
  const [sucesso,    setSucesso]    = useState('');
  const [erro,       setErro]       = useState('');
  // OTP state
  const [otpVisiveis,  setOtpVisiveis]  = useState({});
  const [otpInputs,    setOtpInputs]    = useState({});
  const [otpLoading,   setOtpLoading]   = useState({});
  const [otpErros,     setOtpErros]     = useState({});
  const [acaoLoading,  setAcaoLoading]  = useState({});
  // Modal disputa
  const [disputaModal,    setDisputaModal]    = useState(null);
  const [disputaMotivo,   setDisputaMotivo]   = useState('');
  const [disputaDesc,     setDisputaDesc]     = useState('');
  const [disputaFicheiros,setDisputaFicheiros]= useState([]);

  useEffect(() => { carregar(); }, []);

  const carregar = async () => {
    setLoad(true);
    try {
      const data = await apiFetch('/fornecedor/reservas');
      setReservas(data.reservas || []);
    } catch(e) { setErro(e.message); }
    finally { setLoad(false); }
  };

  const setOtpVisivel  = (id, val) => setOtpVisiveis(p=>({...p,[id]:val}));
  const setOtpInput    = (id, val) => setOtpInputs(p=>({...p,[id]:val}));
  const setOtpLoadingR = (id, val) => setOtpLoading(p=>({...p,[id]:val}));
  const setOtpErro     = (id, val) => setOtpErros(p=>({...p,[id]:val}));
  const setAcaoLoadingR= (id, val) => setAcaoLoading(p=>({...p,[id]:val}));

  const acaoApi = async (id, path, body, msg, metodo = 'POST') => {
    setAcaoLoadingR(id, true);
    try {
      await apiFetch(path, metodo, body);
      setSucesso(msg); setTimeout(()=>setSucesso(''),4000);
      carregar();
    } catch(e) { setErro(e.message); setTimeout(()=>setErro(''),3000); }
    finally { setAcaoLoadingR(id, false); }
  };

  const cancelarReserva = async (id) => {
    setAcaoLoadingR(id, true);
    try {
      await apiFetch(`/reservas/${id}/estado`, 'PATCH', { estado: 'cancelada' });
      setSucesso('Reserva cancelada.'); setTimeout(()=>setSucesso(''),4000);
      carregar();
    } catch(e) { setErro(e.message); setTimeout(()=>setErro(''),3000); }
    finally { setAcaoLoadingR(id, false); }
  };

  const buscarOtp = async (id, endpoint) => {
    setOtpLoadingR(id, true); setOtpErro(id, '');
    try {
      const data = await apiFetch(`/reservas/${id}/${endpoint}`);
      setOtpVisivel(id, data.otp);
    } catch(e) { setOtpErro(id, e.message); }
    finally { setOtpLoadingR(id, false); }
  };

  const confirmarOtpEntrega = async (id) => {
    setOtpLoadingR(id, true); setOtpErro(id, '');
    try {
      await apiFetch(`/reservas/${id}/confirmar-otp-entrega`, 'POST', { codigo: otpInputs[id] });
      setSucesso('Código confirmado! Aluguer activo.'); setTimeout(()=>setSucesso(''),4000);
      setOtpInput(id,''); setOtpVisivel(id,null);
      carregar();
    } catch(e) { setOtpErro(id, e.message); }
    finally { setOtpLoadingR(id, false); }
  };

  const confirmarOtpDevolucao = async (id) => {
    setOtpLoadingR(id, true); setOtpErro(id, '');
    try {
      await apiFetch(`/reservas/${id}/confirmar-otp-devolucao`, 'POST', { codigo: otpInputs[id] });
      setSucesso('Devolução confirmada! Em inspeção.'); setTimeout(()=>setSucesso(''),4000);
      setOtpInput(id,''); setOtpVisivel(id,null);
      carregar();
    } catch(e) { setOtpErro(id, e.message); }
    finally { setOtpLoadingR(id, false); }
  };

  const abrirDisputa = async (id) => {
    if (!disputaMotivo.trim()) { setErro('Indica o motivo da disputa'); return; }
    setAcaoLoadingR(id, true);
    try {
      const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
      const token = localStorage.getItem('kialuga_token');
      const fd = new FormData();
      fd.append('motivo', disputaMotivo);
      fd.append('descricao', disputaDesc);
      disputaFicheiros.forEach(f => fd.append('evidencias', f));
      const res  = await fetch(`${BASE_URL}/reservas/${id}/disputa`, {
        method: 'POST', headers: { Authorization: `Bearer ${token}` }, body: fd,
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.mensagem || 'Erro ao submeter disputa');
      setSucesso('Disputa registada. A KiAluga vai analisar.'); setTimeout(()=>setSucesso(''),4000);
      setDisputaModal(null); setDisputaMotivo(''); setDisputaDesc(''); setDisputaFicheiros([]);
      carregar();
    } catch(e) { setErro(e.message); setTimeout(()=>setErro(''),3000); }
    finally { setAcaoLoadingR(id, false); }
  };

  const tabs = [
    { id:'todas',     label:'Todas',      count: reservas.length },
    { id:'pendente',  label:'Pendentes',  count: reservas.filter(r=>r.estado==='pendente').length },
    { id:'ativa',     label:'Em curso',   count: reservas.filter(r=>ESTADOS_ATIVOS_FORN.includes(r.estado)).length },
    { id:'inspecao',  label:'Inspeção',   count: reservas.filter(r=>r.estado==='em_inspecao').length },
    { id:'concluida', label:'Concluídas', count: reservas.filter(r=>r.estado==='concluida').length },
  ];

  const filtradas = reservas.filter(r => {
    if (activeTab === 'todas')     return true;
    if (activeTab === 'ativa')     return ESTADOS_ATIVOS_FORN.includes(r.estado) && r.estado !== 'em_inspecao';
    if (activeTab === 'inspecao')  return r.estado === 'em_inspecao';
    if (activeTab === 'concluida') return r.estado === 'concluida';
    return r.estado === activeTab;
  });

  return (
    <>
      {/* Modal disputa */}
      {disputaModal && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.65)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'}}
          onClick={e=>{if(e.target===e.currentTarget){setDisputaModal(null);setDisputaFicheiros([]);}}}>
          <div style={{background:'var(--card)',borderRadius:'16px',padding:'24px',width:'100%',maxWidth:'460px',border:'1px solid var(--border)',maxHeight:'90vh',overflowY:'auto'}}>
            <div style={{fontSize:'15px',fontWeight:'700',marginBottom:'4px',color:'var(--danger)'}}>Abrir disputa</div>
            <div style={{fontSize:'12px',color:'var(--text-muted)',marginBottom:'16px'}}>A KiAluga analisará e mediará o processo.</div>

            <div style={{marginBottom:'12px'}}>
              <div style={{fontSize:'12px',fontWeight:'600',marginBottom:'5px'}}>Motivo *</div>
              <input value={disputaMotivo} onChange={e=>setDisputaMotivo(e.target.value)} placeholder="Ex: produto danificado, não devolvido..."
                style={{width:'100%',padding:'9px 12px',border:'1px solid var(--border)',borderRadius:'8px',fontSize:'13px',fontFamily:'inherit',outline:'none',background:'var(--card)',color:'var(--text-primary)',boxSizing:'border-box'}}/>
            </div>

            <div style={{marginBottom:'12px'}}>
              <div style={{fontSize:'12px',fontWeight:'600',marginBottom:'5px'}}>Descrição detalhada</div>
              <textarea value={disputaDesc} onChange={e=>setDisputaDesc(e.target.value)} rows={3} placeholder="Descreve o problema com detalhe..."
                style={{width:'100%',padding:'9px 12px',border:'1px solid var(--border)',borderRadius:'8px',fontSize:'13px',fontFamily:'inherit',outline:'none',background:'var(--card)',color:'var(--text-primary)',resize:'vertical',boxSizing:'border-box'}}/>
            </div>

            {/* Upload evidências */}
            <div style={{marginBottom:'16px'}}>
              <div style={{fontSize:'12px',fontWeight:'600',marginBottom:'5px'}}>
                Evidências <span style={{fontWeight:'400',color:'var(--text-muted)'}}>— fotos/PDF, máx. 5 ficheiros</span>
              </div>
              <label style={{display:'block',border:'1.5px dashed var(--border)',borderRadius:'8px',padding:'14px',textAlign:'center',cursor:'pointer',transition:'border-color 0.15s'}}
                onDragOver={e=>{e.preventDefault();e.currentTarget.style.borderColor='var(--danger)'}}
                onDragLeave={e=>{e.currentTarget.style.borderColor='var(--border)'}}
                onDrop={e=>{e.preventDefault();e.currentTarget.style.borderColor='var(--border)';
                  const novos=[...disputaFicheiros,...Array.from(e.dataTransfer.files)].slice(0,5);
                  setDisputaFicheiros(novos);}}>
                <input type="file" multiple accept="image/*,.pdf" style={{display:'none'}}
                  onChange={e=>{const novos=[...disputaFicheiros,...Array.from(e.target.files)].slice(0,5);setDisputaFicheiros(novos);e.target.value='';}}/>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--text-muted)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{marginBottom:'5px'}}><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                <div style={{fontSize:'12px',color:'var(--text-muted)'}}>Clica ou arrasta ficheiros aqui</div>
              </label>
              {disputaFicheiros.length > 0 && (
                <div style={{display:'flex',flexWrap:'wrap',gap:'8px',marginTop:'10px'}}>
                  {disputaFicheiros.map((f,i)=>(
                    <div key={i} style={{position:'relative',border:'1px solid var(--border)',borderRadius:'8px',overflow:'hidden',width:'70px',height:'70px',background:'var(--bg)'}}>
                      {f.type.startsWith('image/') ? (
                        <img src={URL.createObjectURL(f)} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}}/>
                      ) : (
                        <div style={{width:'100%',height:'100%',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:'4px'}}>
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--danger)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                          <div style={{fontSize:'9px',color:'var(--text-muted)',textAlign:'center',marginTop:'3px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',width:'60px'}}>{f.name}</div>
                        </div>
                      )}
                      <button onClick={()=>setDisputaFicheiros(p=>p.filter((_,j)=>j!==i))}
                        style={{position:'absolute',top:'2px',right:'2px',width:'16px',height:'16px',borderRadius:'50%',background:'rgba(220,38,38,0.85)',border:'none',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',padding:0}}>
                        <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div style={{display:'flex',gap:'8px'}}>
              <button className="btn btn-ghost" onClick={()=>{setDisputaModal(null);setDisputaFicheiros([]);}} style={{flex:1}}>Cancelar</button>
              <button className="btn" onClick={()=>abrirDisputa(disputaModal)} disabled={acaoLoading[disputaModal]}
                style={{flex:2,background:'var(--danger)',color:'#fff',border:'none',display:'flex',alignItems:'center',justifyContent:'center',gap:'6px'}}>
                {acaoLoading[disputaModal]?'A submeter...':'Confirmar disputa'}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="topbar">
        <div>
          <div className="topbar-title">Reservas</div>
          <div className="topbar-sub">{reservas.length} total · {reservas.filter(r=>r.estado==='pendente').length} pendentes · {reservas.filter(r=>r.estado==='em_inspecao').length} em inspeção</div>
        </div>
        <div className="topbar-actions">
          <button className="btn btn-outline" onClick={carregar} style={{display:'flex',alignItems:'center',gap:'6px'}}>
            <RefreshIcon size={14}/> Actualizar
          </button>
        </div>
      </div>

      <div className="page-content">
        {erro    && <div style={{background:'var(--danger-bg)',border:'1px solid var(--danger-border)',borderRadius:'10px',padding:'11px 14px',marginBottom:'14px',fontSize:'13px',color:'var(--danger)',display:'flex',gap:'7px',alignItems:'center'}}><AlertIcon size={14}/>{erro}</div>}
        {sucesso && <div style={{background:'var(--success-bg)',border:'1px solid var(--success-border)',borderRadius:'10px',padding:'11px 14px',marginBottom:'14px',fontSize:'13px',color:'var(--success)',display:'flex',gap:'7px',alignItems:'center'}}><CheckIcon size={14}/>{sucesso}</div>}

        {/* Tabs */}
        <div style={{display:'flex',gap:'6px',marginBottom:'16px'}}>
          {tabs.map(t=>(
            <button key={t.id} onClick={()=>setActiveTab(t.id)} style={{
              padding:'7px 14px',borderRadius:'8px',fontSize:'12px',fontWeight:'500',cursor:'pointer',fontFamily:'inherit',transition:'all 0.15s',
              background:activeTab===t.id?'var(--orange)':'var(--card)',
              color:activeTab===t.id?'#fff':'var(--text-secondary)',
              border:`1px solid ${activeTab===t.id?'var(--orange)':'var(--border)'}`,
            }}>
              {t.label} ({t.count})
            </button>
          ))}
        </div>

        {load ? (
          <div style={{textAlign:'center',padding:'60px',color:'var(--text-muted)'}}>
            <ClockIcon size={32} color='var(--border)'/>
            <div style={{marginTop:'10px'}}>A carregar reservas...</div>
          </div>
        ) : filtradas.length === 0 ? (
          <div className="card" style={{textAlign:'center',padding:'60px'}}>
            <ReceiptIcon size={36} color='var(--border)'/>
            <div style={{fontSize:'15px',fontWeight:'600',margin:'12px 0 6px'}}>Sem reservas</div>
            <div style={{fontSize:'13px',color:'var(--text-muted)'}}>As reservas dos teus anúncios aparecem aqui.</div>
          </div>
        ) : (
          <div style={{display:'flex',flexDirection:'column',gap:'12px'}}>
            {filtradas.map(r => {
              const est = ESTADOS[r.estado] || { label:r.estado, cls:'badge-neutral' };
              return (
                <div key={r.id} className="card">
                  <div style={{display:'flex',gap:'12px',alignItems:'flex-start'}}>
                    <div style={{width:'60px',height:'60px',borderRadius:'10px',overflow:'hidden',flexShrink:0,background:'linear-gradient(135deg,#fde8d8,#fed7b0)',display:'flex',alignItems:'center',justifyContent:'center'}}>
                      {r.fotos?.[0]
                        ? <img src={r.fotos[0]} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}} onError={e=>e.target.style.display='none'}/>
                        : <PackageIcon size={22} color='#F97316'/>
                      }
                    </div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:'8px',marginBottom:'6px'}}>
                        <div>
                          <div style={{fontSize:'14px',fontWeight:'600',color:'var(--text-primary)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',maxWidth:'300px'}}>{r.titulo||'Produto'}</div>
                          <div style={{display:'flex',alignItems:'center',gap:'6px',marginTop:'3px'}}>
                            <div style={{width:'22px',height:'22px',borderRadius:'50%',background:'var(--brand-mid)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'10px',fontWeight:'700',color:'#fff',flexShrink:0}}>
                              {(r.cliente_nome||'?')[0].toUpperCase()}
                            </div>
                            <span style={{fontSize:'12px',color:'var(--text-muted)'}}>{r.cliente_nome||'Cliente'}</span>
                          </div>
                        </div>
                        <span className={`badge ${est.cls}`}>{est.label}</span>
                      </div>

                      <div style={{display:'flex',gap:'16px',flexWrap:'wrap',marginBottom:'10px'}}>
                        {[
                          ['Início',   new Date(r.data_inicio).toLocaleDateString('pt-PT')],
                          ['Fim',      new Date(r.data_fim).toLocaleDateString('pt-PT')],
                          ['Dias',     `${r.total_dias} dia${r.total_dias>1?'s':''}`],
                          ['Aluguer',  `${parseFloat(r.valor_aluguer||0).toLocaleString()} Kz`],
                          ['Caução',   `${parseFloat(r.valor_caucao||0).toLocaleString()} Kz`],
                          ['Escrow',   r.escrow_liberado ? 'Pago' : 'Retido'],
                        ].map(([l,v])=>(
                          <div key={l}>
                            <div style={{fontSize:'10px',color:'var(--text-muted)',textTransform:'uppercase',letterSpacing:'0.3px'}}>{l}</div>
                            <div style={{fontSize:'12px',fontWeight:'600',color:
                              l==='Escrow' ? (r.escrow_liberado?'var(--success)':'var(--warning)') :
                              l==='Aluguer' ? 'var(--success)' :
                              'var(--text-primary)'
                            }}>{v}</div>
                          </div>
                        ))}
                      </div>

                      {/* ── Painel OTP: Modo A (fornecedor entrega): fornecedor INSERE o código do cliente ── */}
                      {['confirmada','em_transito_entrega'].includes(r.estado) && r.modo_entrega !== 'levantamento' && (
                        <PainelOtp
                          titulo="Confirmar entrega (OTP #1)"
                          instrucao="Pede o código ao cliente e introduz abaixo para confirmar que entregaste o produto."
                          inputVal={otpInputs[r.id]||''}
                          onChangeInput={v=>setOtpInput(r.id,v)}
                          onConfirmar={()=>confirmarOtpEntrega(r.id)}
                          loading={otpLoading[r.id]}
                          erro={otpErros[r.id]}
                          confirmLabel="Confirmar entrega"
                        />
                      )}
                      {/* ── Painel OTP: Modo B (levantamento): fornecedor VÊ e mostra o código ao cliente ── */}
                      {r.estado === 'aguardando_levantamento' && r.modo_entrega === 'levantamento' && (
                        <PainelOtp
                          titulo="Código de levantamento (OTP #1)"
                          instrucao="Quando o cliente chegar, mostra-lhe este código para confirmar o levantamento."
                          otp={otpVisiveis[r.id]}
                          onBuscarOtp={!otpVisiveis[r.id] ? () => buscarOtp(r.id, 'otp-entrega') : null}
                          loading={otpLoading[r.id]}
                          erro={otpErros[r.id]}
                        />
                      )}
                      {/* ── Painel OTP devolução: Modo A: fornecedor VÊ e diz o código ao cliente ── */}
                      {r.estado === 'em_transito_devolucao' && r.modo_entrega !== 'levantamento' && (
                        <PainelOtp
                          titulo="Código de devolução (OTP #2)"
                          instrucao="Quando o cliente trouxer o produto, diz-lhe este código para ele confirmar a devolução."
                          otp={otpVisiveis[r.id]}
                          onBuscarOtp={!otpVisiveis[r.id] ? () => buscarOtp(r.id, 'otp-devolucao') : null}
                          loading={otpLoading[r.id]}
                          erro={otpErros[r.id]}
                        />
                      )}
                      {/* ── Painel OTP devolução: Modo B: fornecedor INSERE o código do cliente ── */}
                      {r.estado === 'em_transito_devolucao' && r.modo_entrega === 'levantamento' && (
                        <PainelOtp
                          titulo="Confirmar devolução (OTP #2)"
                          instrucao="Pede o código ao cliente e introduz abaixo para confirmar que recebeste o produto de volta."
                          inputVal={otpInputs[r.id]||''}
                          onChangeInput={v=>setOtpInput(r.id,v)}
                          onConfirmar={()=>confirmarOtpDevolucao(r.id)}
                          loading={otpLoading[r.id]}
                          erro={otpErros[r.id]}
                          confirmLabel="Confirmar recepção"
                        />
                      )}
                      {/* ── Painel inspeção ── */}
                      {r.estado === 'em_inspecao' && (
                        <div style={{background:'var(--warning-bg,#fffbeb)',border:'1.5px solid var(--warning,#f59e0b)',borderRadius:'10px',padding:'14px 16px',marginTop:'10px'}}>
                          <div style={{fontSize:'13px',fontWeight:'700',color:'#92400e',marginBottom:'4px'}}>Inspecionar produto devolvido</div>
                          <div style={{fontSize:'12px',color:'var(--text-secondary)',marginBottom:'10px'}}>
                            Tens até {r.inspecao_prazo ? new Date(r.inspecao_prazo).toLocaleString('pt-PT') : '24h'} para inspecionar.
                            Se não te manifestares, o escrow será libertado automaticamente.
                          </div>
                          <div style={{display:'flex',gap:'8px',flexWrap:'wrap'}}>
                            <button className="btn btn-success btn-sm"
                              onClick={()=>acaoApi(r.id, `/reservas/${r.id}/confirmar-inspecao`, {}, 'Inspecção confirmada! Pagamento libertado.')}
                              disabled={acaoLoading[r.id]}
                              style={{display:'flex',alignItems:'center',gap:'5px'}}>
                              <CheckIcon size={12}/> {acaoLoading[r.id]?'...':'Confirmar bom estado'}
                            </button>
                            <button className="btn btn-sm"
                              onClick={()=>setDisputaModal(r.id)}
                              style={{background:'var(--danger-bg)',color:'var(--danger)',border:'1px solid var(--danger-border)',display:'flex',alignItems:'center',gap:'5px'}}>
                              <AlertIcon size={12}/> Reportar problema
                            </button>
                          </div>
                        </div>
                      )}

                      <div style={{display:'flex',gap:'6px',flexWrap:'wrap',marginTop:'8px'}}>
                        {/* Pendente: confirmar pedido (usa novo endpoint que gera OTP #1) */}
                        {r.estado === 'pendente' && (
                          <>
                            <button className="btn btn-success btn-sm"
                              onClick={()=>acaoApi(r.id, `/reservas/${r.id}/confirmar-pedido`, {}, 'Pedido confirmado! OTP gerado.')}
                              disabled={acaoLoading[r.id]}
                              style={{display:'flex',alignItems:'center',gap:'5px'}}>
                              <CheckIcon size={12}/> {acaoLoading[r.id]?'...':'Confirmar pedido'}
                            </button>
                            <button className="btn btn-sm"
                              onClick={()=>cancelarReserva(r.id)}
                              disabled={acaoLoading[r.id]}
                              style={{background:'var(--danger-bg)',color:'var(--danger)',border:'1px solid var(--danger-border)',display:'flex',alignItems:'center',gap:'5px'}}>
                              <XIcon size={12}/> Cancelar
                            </button>
                          </>
                        )}
                        {/* Modo A: marcar em trânsito (opcional) */}
                        {r.estado === 'confirmada' && r.modo_entrega === 'entrega' && (
                          <button className="btn btn-sm"
                            onClick={()=>acaoApi(r.id, `/reservas/${r.id}/em-transito`, {}, 'Marcado em trânsito!')}
                            disabled={acaoLoading[r.id]}
                            style={{background:'var(--info-bg)',color:'var(--info)',border:'1px solid var(--info-border)',display:'flex',alignItems:'center',gap:'5px'}}>
                            <TruckIcon size={12}/> Marcar em trânsito
                          </button>
                        )}
                        {ESTADOS_CHAT.includes(r.estado) && (
                          <button className="btn btn-sm" onClick={()=>navigate(`/fornecedor/chat/${r.id}`)}
                            style={{background:'var(--primary)',color:'#fff',border:'none',display:'flex',alignItems:'center',gap:'5px'}}>
                            <MessageIcon size={12}/> Chat
                          </button>
                        )}
                        {r.notas && (
                          <span style={{fontSize:'11px',color:'var(--text-muted)',fontStyle:'italic',padding:'4px 0'}}>
                            Nota: {r.notas}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
}
